import { render, staticRenderFns } from "./MusicianRecord.vue?vue&type=template&id=30d2fffe&scoped=true&"
import script from "./MusicianRecord.vue?vue&type=script&lang=js&"
export * from "./MusicianRecord.vue?vue&type=script&lang=js&"
import style0 from "./MusicianRecord.vue?vue&type=style&index=0&id=30d2fffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d2fffe",
  null
  
)

export default component.exports